module.exports = __webpack_public_path__ + "img/next.4183a7c5.svg";